import React, { useEffect, useState } from 'react';
import { ClassNames } from '../../../helper';
import { MdContentCopy } from "react-icons/md";
import { RiDeleteBin3Line } from "react-icons/ri";
import { Button } from "../../../components";
import {
    handleSaveAddPersona,
    handleSaveDeletePersona,
} from "../../../helper/customizedNudge";

const CustomizeNudgeStats = ({ usersNudgeData = {}, userPersonaTypes, user }) => {
    // console.log("------usersNudgeData-------", usersNudgeData);
    const [nudgeStat, setNudgeStat] = useState({});

    const getOptionName = (key) => {
        return userPersonaTypes.find(persona => persona.optionValue === key)?.optionName || '';
    }

    const getNudgeStats = (nudgeData) => {
        let temp = {};
        for (let [key, val] of Object.entries(nudgeData)) {
            let optionName = getOptionName(key);
            let title = getNudgeTitle(optionName);
            let active = getNudgeStatus(val);
            let couponCode = getCouponCode(val);
            temp[key] = { key, optionName, title, active, couponCode };
        }
        return temp;
    };

    const getNudgeTitle = (nudgeTitle) => {
        return nudgeTitle?.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/, "");
    }

    const getNudgeStatus = (nudgeData) => {
        let status = nudgeData?.nudgeShowing?.customizeProperties?.status?.propertyValue;
        return status === "ON";
    }

    const getCouponCode = (nudgeData) => {
        return nudgeData?.nudgeCouponCode?.customizeProperties?.text?.propertyValue || '';
    }

    const handleDuplicate = async (persona) => {
        const confirmDuplicate = window.confirm(`Are you sure you want to duplicate "${persona.title}"?`);
        if (!confirmDuplicate) return;
        try {
            await handleSaveAddPersona(
                user,
                userPersonaTypes,
                {
                    optionName: persona.optionName,
                    optionValue: persona.key
                },
                true
            );
        } catch (error) {
            console.error("Failed to duplicate persona:", error);
        }
    };

    const handleDelete = async (persona) => {
        const confirmDelete = window.confirm(`Are you sure you want to delete "${persona.title}"?`);
        if (!confirmDelete) return;
        try {
            await handleSaveDeletePersona(
                user,
                userPersonaTypes,
                {
                    optionName: persona.optionName,
                    optionValue: persona.key
                }
            );
        } catch (error) {
            console.error("Failed to delete persona:", error);
        }
    };

    useEffect(() => {
        if (!usersNudgeData || Object.keys(usersNudgeData).length === 0) return;
        let result = getNudgeStats(usersNudgeData);
        setNudgeStat(result);
    }, [usersNudgeData, userPersonaTypes]);

    return (
        <div className='bg-white m-4 mt-1 border rounded-md shadow-md p-4'>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-300 border rounded-lg">
                    <thead>
                        <tr className="divide-x divide-gray-300">
                            <th
                                scope="col"
                                className="py-3.5 px-2 text-left text-sm font-semibold text-gray-900"
                            >
                                Persona Name
                            </th>
                            <th
                                scope="col"
                                className="py-3.5 px-2 text-center text-sm font-semibold text-gray-900"
                            >
                                Coupon Code
                            </th>
                            <th
                                scope="col"
                                className="px-2 py-3.5 text-center text-sm font-semibold text-gray-900"
                            >
                                Status
                            </th>
                            <th
                                scope="col"
                                className="px-2 py-3.5 text-center text-sm font-semibold text-gray-900 w-1"
                            >
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-300 bg-white">
                        {Object.values(nudgeStat)?.map((persona) => (
                            <tr key={persona.key} className="divide-x divide-gray-300">
                                <td className="whitespace-nowrap p-2 text-sm font-medium text-gray-900">
                                    {persona.title}
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-center text-blue-700">
                                    {persona.couponCode}
                                </td>
                                <td className={ClassNames(
                                    "whitespace-nowrap p-2 text-sm text-center",
                                    persona.active ? "text-green-600" : "text-red-600"
                                )}>
                                    {persona.active ? "Enabled" : "Disabled"}
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-center w-1">
                                    <div className="flex justify-center items-center gap-3">
                                        <Button
                                            Icon={MdContentCopy}
                                            active={false}
                                            onClick={() => handleDuplicate(persona)}
                                            title="DUPLICATE"
                                            className="!bg-blue-600 hover:!bg-blue-700 transition-colors duration-200 shadow-sm"
                                        />
                                        <Button
                                            Icon={RiDeleteBin3Line}
                                            active={false}
                                            onClick={() => handleDelete(persona)}
                                            title="DELETE"
                                            className="!bg-red-500 hover:!bg-red-600 transition-colors duration-200 shadow-sm"
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CustomizeNudgeStats;